// src/index.js
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import './i18n'; // Import the i18next configuration
import './index.css';
import App from './App';
import { UserProvider } from './context/UserContext'; // Import UserProvider
import ErrorFallback from './components/error/ErrorFallback';
import { initializeDebugMode } from './utils/debugUtils';

initializeDebugMode(); // Run this before rendering the App

// Polyfill for crypto.randomUUID for older Node.js environments like in react-snap
if (typeof crypto.randomUUID !== 'function') {
  crypto.randomUUID = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
}

const rootElement = document.getElementById('root');

const logError = (error, info) => {
  // In a real app, you would send this to a logging service
  console.error('Caught an error:', error, info);
};

const app = (
  <React.StrictMode>
    <UserProvider>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={logError}
        onReset={() => {
          window.location.href = '/';
        }}
      >
        <App />
      </ErrorBoundary>
    </UserProvider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  const root = createRoot(rootElement);
  root.render(app);
}
